<template>
  <div>
    <div class="row">
      <div class="col-12">
          <TitlePage :title="title" :items="items"> </TitlePage>
      </div>
      <div class="col-12 d-flex pb-4">
        <SelectLocation
          :value="listLocation" 
          @getLocation="listLocation = $event, runLoad()"
          @listLocationAll="listLocationAll($event)"
        />
        <date-range-picker
          v-model="dateRange"
          opens="center"
          @update="runLoad"
          :ranges="ranges"
          :locale-data="locale"
          :maxDate="locale.maxDate"
          class="dashboard-datepicker"
        >
          <template #ranges="ranges">
            <div class="ranges">
              <ul>
                <li
                  v-for="(range, name) in ranges.ranges"
                  :key="name"
                  @click="getDate(ranges, range)"
                >
                  <b>{{ name }}</b>
                </li>
              </ul>
            </div>
          </template>
        </date-range-picker>
      </div>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <bar-chart
              v-if="!loading"
              :height="300"
              :datas="datas"
              :categories="categories"
              :size="50"
              :time="dateRange"
              :typeTime="dimensionTime"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <table class="table b-table">
              <thead class="thead-light">
                <tr>
                  <th width="15%">Tên khách hàng</th>
                  <th width="8%">SĐT khách hàng</th>
                  <th class="text-right" width="10%">SL đơn hàng</th>
                  <th class="text-right" width="10%">SL hàng bán ra</th>
                  <th class="text-right" width="12%">Doanh thu</th>
                  <th class="text-right" width="12%">Doanh thu giảm trừ</th>
                  <th class="text-right pointer" width="10%"  @click="clickSort('netRevenue', type=='Asc' ? 'Desc' : 'Asc')">
                      Doanh thu thuần
                    <img src="@/assets/images/arrow-up-square.png" v-if="sortType == 'netRevenueDesc'"/>
                    <img src="@/assets/images/arrow-down-square.png" v-if="sortType == 'netRevenueAsc'"/>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in dataReportCus" :key="key">
                  <td>{{item.customerName}}</td>
                  <td>{{item.tel}}</td>
                  <td class="text-right">{{formatMoneyNotUnitExt(item.numberOrders)}}</td>
                  <td class="text-right">{{formatMoneyNotUnitExt(item.numberItems)}}</td>
                  <td class="text-right">{{formatMoneyNotUnitExt(item.grossAmount)}}</td>
                  <td class="text-right">{{formatMoneyNotUnitExt(item.subProfit)}}</td>
                  <td class="text-right">{{formatMoneyNotUnitExt(item.netRevenue)}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="text-right text-bold">{{formatMoneyNotUnitExt(dataTotalShow.numberOrders)}}</td>
                  <td class="text-right text-bold">{{formatMoneyNotUnitExt(dataTotalShow.numberItems)}}</td>
                  <td class="text-right text-bold">{{formatMoneyNotUnitExt(dataTotalShow.grossAmount)}}</td>
                  <td class="text-right text-bold">{{formatMoneyNotUnitExt(dataTotalShow.subProfit)}}</td>
                  <td class="text-right text-bold">{{formatMoneyNotUnitExt(dataTotalShow.netRevenue)}}</td>
                </tr>
              </tbody>
            </table>
            <b-pagination @change="changePage" v-model="currentPage" :total-rows="totalRecord" :per-page="sizePage" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
          </div>
        </div>
      </div>
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import SelectLocation from "@/pages/report/components/select-location.vue"
import { ReportService } from "@/services/nextshop/report.service";
import parseDateReport from "@/mixins/reports/parseDateReport"
import { Bar } from "vue-chartjs"
import BarChart from '../components/bar-chart.vue'

export default {
  extends: Bar,

  page: {
    title: "DOANH THU THEO KHÁCH HÀNG",
  },

  mixins: [
    parseDateReport
  ],

  components: {
    DateRangePicker,
    SelectLocation,
    BarChart
  },

  data() {
    return {
      appId: process.env.VUE_APP_ID,
      listLocation: [VueCookies.get("LID")],
      LID: VueCookies.get("LID"),
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      title: "DOANH THU THEO KHÁCH HÀNG",
      items: [
        { text: "Báo cáo doanh thu", href: "/report-revenue" },
        { text: "Theo thời gian", active: true },
      ],
      locale: {
        maxDate: moment().format('YYYY-MM-DD'),
        format: "dd/mm/yyyy",
        applyLabel: "Xác nhận",
        cancelLabel: "Hủy",
        daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        monthNames: [
          "Tháng 1",
          "Tháng 2",
          "Tháng 3",
          "Tháng 4",
          "Tháng 5",
          "Tháng 6",
          "Tháng 7",
          "Tháng 8",
          "Tháng 9",
          "Tháng 10",
          "Tháng 11",
          "Tháng 12",
        ],
      },
      loading: false,
      dateRange: {
        startDate:moment().subtract(30, "day")._d,
        endDate: moment().subtract(0, "day")._d
      },
      dataReportCus: [],
      dataTotalShow: {
        numberOrders: 0,
        numberItems: 0,
        netRevenue: 0,
        grossAmount: 0,
        subProfit: 0
      },
      currentPage: 1,
      totalRecord: 0,
      sizePage: 30,
      sort: 'netRevenue',
      type: 'Desc',
      sortType: 'netRevenueDesc',
      arrLocal:[],
      dimensionTime: "DAY",
      isRealtime: true
    }
  },

  async created() {
    await this.runLoad()
  },

  computed: {
    ranges() {
      return {
        "Hôm nay": [moment()._d, moment()._d],
        "Hôm qua": [
          moment().subtract(1, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "7 ngày trước": [
          moment().subtract(7, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "30 ngày trước": [
          moment().subtract(30, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "Tuần trước": [
          moment().subtract(1, "week").startOf("week")._d,
          moment().subtract(1, "week").endOf("week")._d,
        ],
        "Tháng trước": [
          moment().subtract(1, "month").startOf("month")._d,
          moment().subtract(1, "month").endOf("month")._d,
        ],
        "3 tháng trước": [
          moment().startOf("month").subtract(3, "month")._d,
          moment().endOf("month").subtract(1, "month")._d,
        ],
        "Đầu tuần đến nay": [moment().startOf("week")._d, moment().subtract(0, "days")._d],
        "Đầu tháng đến nay": [moment().startOf("month")._d, moment().subtract(0, "days")._d],
        "Đầu năm đến nay": [moment().startOf("year")._d, moment().subtract(0, "days")._d],
      };
    }
  },

  methods: {
    getDate(ranges, range) {
      ranges.clickRange(range);
    },
    async getListDay(data) {
      const dt = data + "01";
      this.dateRange = {
        startDate: moment(dt).startOf("month"),
        endDate: moment(dt).endOf("month"),
      }
    },
    async runLoad(){
      await this.totalReportV3()
      await this.cusReportV3()
    },
    async changePage(page) {
      this.currentPage = page
      await this.cusReportV3();
    },
    async clickSort(sort, type) {
      this.sort = sort
      this.type = type
      this.sortType = sort+type
      await this.cusReportV3();
    },
    async cusReportV3(){
      this.checkRangDate()
      this.dataReportCus = []
      this.categories = []
      this.datas = []
      this.loading = true
      const strLocation = (this.listLocation.length > 0) ? this.listLocation.join() : this.LID

      const getParams = {
        "dimensionTime": "DAY",
        "locationId": strLocation,
        "fromDate": moment(this.dateRange.startDate).format('YYYYMMDD'),
        "toDate": moment(this.dateRange.endDate).format('YYYYMMDD'),
        "sort": this.sortType,
        "isRealtime": this.isRealtime,
        "page": this.currentPage,
        "perPage": this.sizePage
      }
      const response = await ReportService.customerReportV3(getParams)
      if(response.success){
        response.data.map((item)=>{
        
          item.addedFee = Math.ceil(this.divisionThousand(item.addedFee))
          item.grossAmount = Math.ceil(this.divisionThousand(item.grossAmount))
          item.netRevenue = Math.ceil(this.divisionThousand(item.netRevenue))
          item.subProfit = Math.ceil(this.divisionThousand(item.subProfit))
          
          const tmp = {
            customerName: item.customerName,
            tel: item.tel,
            numberOrders: item.numberOrders,
            numberItems: item.numberItems,
            grossAmount: item.grossAmount,
            subProfit: item.subProfit,
            netRevenue: item.netRevenue
          }
          this.dataReportCus.push(tmp)

          this.categories.push(Number(item.customerName));
          this.datas.push(item.grossAmount);
        })
      }
      this.loading = false
    },
    async totalReportV3() {
      try {
        this.checkRangDate()
        const strLocation = (this.listLocation.length > 0) ? this.listLocation.join() : this.LID
        this.dataTotalShow = {
          numberOrders: 0,
          numberItems: 0,
          netRevenue: 0,
          grossAmount: 0,
          subProfit: 0
        }
        const params = {
          "dimensionTime": "DAY",
          "locationId": strLocation,
          "orderStatus": "SUCCESS",
          "fromDate": moment(this.dateRange.startDate).format('YYYYMMDD'),
          "toDate": moment(this.dateRange.endDate).format('YYYYMMDD'),
          "isRealtime": this.isRealtime
        }
        const response = await ReportService.totalCustomerReportV3(params)
        if(response.success){
          this.totalRecord = response.data[0].totalRecord
          this.currentPage = 1
          this.dataTotalShow.numberOrders = response.data[0].numberOrders
          this.dataTotalShow.numberItems = response.data[0].numberItems
          this.dataTotalShow.netRevenue = this.divisionThousand(response.data[0].netRevenue)
          this.dataTotalShow.grossAmount = this.divisionThousand(response.data[0].grossAmount)
          this.dataTotalShow.subProfit = this.divisionThousand(response.data[0].subProfit)
        }
      } catch (error) {
        this.loading = false;
      }
    },
    listLocationAll(data){
      this.arrLocal = []
      if(data.length > 0){
        data.map((e)=>{
          this.arrLocal.push({
            id: e.coLocationId,
            text: e.name
          })
        })
      }
    },
    checkRangDate(){
      const endDate = moment(this.dateRange.endDate).format('YYYYMMDD')
      const currentDate = moment(new Date()).format('YYYYMMDD')
      if(endDate != currentDate){
        this.isRealtime = false
      }else{
        this.isRealtime = true
      }
    }
  }
};
</script>
<style scoped>
  ul.pagination{margin-bottom: 0;}
  ::v-deep .vue-daterange-picker{min-width: 225px;}
  .pointer{cursor: pointer;}
</style>